import NewModule from './NewModule';

export default NewModule;
